import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PressePage from './components/PressePage/PressePage';
import NewsPage from './components/NewsPage/NewsPage';
import reportWebVitals from './reportWebVitals';

// Einfaches Routing ohne Router-Bibliothek: /presse zeigt den Pressebereich,
// /news alle Neuigkeiten, alles andere die Hauptseite. Server-seitig sorgt
// public/.htaccess dafuer, dass diese Pfade auf die index.html ausgeliefert werden.
const path = window.location.pathname.replace(/\/+$/, '').toLowerCase();
const PAGES = {
  '/presse': PressePage,
  '/news': NewsPage,
};
const Page = PAGES[path] || App;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Page />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
